import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import swal from 'sweetalert2';
import { ServicioService } from "../services/servicio.services";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { auth, cambio } from 'app/models/ejemplo.model';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';

interface FormModel {
  captcha?: string;
}
@Component({
  selector: 'app-cambio-pass',
  templateUrl: './cambio-pass.component.html',
  styleUrls: ['./cambio-pass.component.css']
})
export class CambioPassComponent implements OnInit {
  public cargando:any = false;
  public estado:any = 0;
  constructor(private _servicios: ServicioService, private _router: Router) { }
  token: any;
  usuariodb: any;
  password_old:string="";
  fpassword_1:string="";
  fpassword_2:string = "";
  flag: any;

  textValidator:any = "";

  regex = new Array();

  loginForm = new FormGroup({
    oldpassword: new FormControl("",Validators.required),
    fpassword1: new FormControl("",[Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&=<>¿.,])[A-Za-z\d$@$!%*?&].{8,}')]),
    fpassword2: new FormControl("",Validators.required),
    captcha: new FormControl("",Validators.required),
  });
  ngOnInit() {
    // if(sessionStorage.getItem("token")== null){
    //   this._router.navigateByUrl("login");
    // }
    this.password_old = "";
    this.fpassword_1 = "";
    this.fpassword_2="";
    this.loginForm.patchValue({
      
      oldpassword:this.password_old,
      fpassword1:this.fpassword_1,
      fpassword2:this.fpassword_2,
    });

  }
  explicar(){
    // if(this.estado == 0){
    //   this.estado = 1;
    // }else{
    //   this.estado = 0;
    // }
    
    
    swal({
      title: 'La contraseña debe tener un mínimo de 8 dígitos, debe contar con mayúsculas, minúsculas y tener al menos 1 carácter no alfanumérico $@$!%*?&=<>¿.,',
      type: 'info'
    })
  }

  cambio(e){
    this.cargando = true;
    var contraseñas = new cambio();
    contraseñas.cliente = sessionStorage.getItem('cliente');
    contraseñas.usuario = sessionStorage.getItem('usuario');
    contraseñas.oldPassword = this.password_old;
    contraseñas.newPassword = this.fpassword_1;
    e.preventDefault();
    if(this.password_old != this.fpassword_1 || this.fpassword_1 == this.fpassword_2){

      this._servicios.cambiarContraseña(contraseñas).subscribe(
        result => {
          this.cargando = false;

          if(result == "usada"){
            swal({
              title: 'Problema la contraseña ya fue usada, debe crear una nueva contraseña.',
              type: 'warning',
            })
          }

          if(result == "Ok"){

            swal({
              title: 'Contraseña Actualizada con Exito.',
              type: 'success',
            })

            sessionStorage.removeItem("cliente");
            sessionStorage.removeItem("token");
            sessionStorage.clear;
            this._router.navigateByUrl("login");
          }
  
        },
        error=>{
          this.cargando = false;
          
        },
        
        ()=>{this._router.navigateByUrl("R-hormigones")}
      );
    }else{
      if(this.fpassword_1 != this.fpassword_2){
        swal({
          title: 'La nueva contraseña no coincide con la confirmación.',
          type: 'warning',
        });
        this.fpassword_2 = "";

      }else{
      swal({
        title: 'La contraseña Anterior debe ser diferente a la nueva.',
        type: 'warning',
      });
      this.fpassword_1 = "";
      this.fpassword_2 = "";
    }
  }
    
  }

  validarContrasena(contrasena:string){

    if(contrasena == ""){
      return "";
    }

    if(contrasena.match("(?=.*[a-z])") && contrasena.match("(?=.*[A-Z])") && contrasena.match("(?=.*[0-9])") && contrasena.match("(?=.*[$@$!%*?&=<>¿.,])") && contrasena.length >= 8){
      return "Fuerte";
    }
    else if((contrasena.match("(?=.*[a-z])") || contrasena.match("(?=.*[A-Z])")) && contrasena.match("(?=.*[0-9])")){
      return "Medio";
    }
    else if(contrasena.match("(?=.*[a-z])")){
      return "Debil";
    }


  }

}



// WEBPACK FOOTER //
// ./src/app/cambio-pass/cambio-pass.component.ts